import React, { useEffect, useMemo, useRef, useState } from 'react';
import moment from 'moment';
import './index.less';
import { addZero } from '@/common/utils';
import { Table, Input, Button, InputNumber, Modal, Popover, Tooltip } from '@drip/drip-design';
import { ITEM_COLOR } from '../data';
import SetPlan from './add-plan';
import { cloneDeep } from 'lodash';
import TimestampRangePicker from '@/components/timestamp-RangePicker';
import Delete from '@/components/delete';
import { thousands } from '@/common/utils';
import classnames from 'classnames';

function getDataSpace(date1, date2) {
  const _date1 = moment(date1).format('YYYY-MM-DD');
  const _date2 = moment(date2).format('YYYY-MM-DD');
  let range = moment(_date1).diff(moment(_date2), 'day');
  if (range < 0) {
    range = range * -1;
  }
  return range + 1;
}

function getStyle(index) {
  return {
    backgroundColor: ITEM_COLOR[index].sub,
    borderLeft: `8px solid ${ITEM_COLOR[index].main}`,
    borderRight: `8px solid ${ITEM_COLOR[index].main}`,
  };
}

const getCurrMonth = (data) => {
  return moment(data).get('month') + 1;
};
const getCurrYear = (data) => {
  return moment(data).get('year');
};
const getCurrDate = (data) => {
  return moment(data).get('date');
};
const getCurrYearMonth = (data) => {
  return moment(data).format('YYYY-MM');
};
const getDaysInMonth = (date) => {
  return moment(getCurrMonth(date), 'M').daysInMonth();
};
const getArray = (start, end) => {
  return Array.from(Array(end - start + 1)).map((e, i) => addZero(start + i));
};
const getCalendarArray = (start, end) => {
  const monthLength = getCurrYear(end) * 12 + getCurrMonth(end) - (getCurrYear(start) * 12 + getCurrMonth(start));
  return Array.from(Array(monthLength + 1)).map((e, i) => {
    const currentMonth = moment(start).add(i, 'M');
    let daysArray = [];
    if (monthLength == 0) {
      let daysLength = moment(end).diff(moment(start), 'days');
      let startDay = getCurrDate(start);
      daysArray = Array.from(Array(daysLength + 1)).map((a, key) => addZero(startDay + key));
    } else {
      if (i == 0) {
        let daysLength = currentMonth.endOf('months').diff(moment(start), 'days');
        let startDay = getCurrDate(start);
        daysArray = Array.from(Array(daysLength + 1)).map((a, key) => addZero(startDay + key));
      } else if (i == monthLength) {
        let daysLength = moment(end).diff(currentMonth.startOf('months'), 'days');
        daysArray = Array.from(Array(daysLength + 1)).map((a, key) => addZero(1 + key));
      } else {
        let daysLength = getDaysInMonth(currentMonth);
        daysArray = Array.from(Array(daysLength)).map((a, key) => addZero(1 + key));
      }
    }
    return {
      currentMonth: currentMonth.format('YYYY-MM'),
      daysArray,
    };
  });
};

// const currentMonthDays = getCalendarArray(moment(), moment().add(21, 'days'));

const disabledDate = (current, outerTime, levelPlan, allowTime) => {
  // 自身时间范围内可选 allowTime
  if (allowTime && moment(allowTime.startTime) <= current && current <= moment(allowTime.endTime).endOf('day')) {
    return false;
  }
  if (current <= moment(outerTime.startTime).startOf('day') || moment(outerTime.endTime).endOf('day') <= current) {
    return true;
  }
  if (
    levelPlan.some(
      (item) => moment(item.startTime).startOf('day') <= current && current <= moment(item.endTime).endOf('day')
    )
  ) {
    return true;
  }
  return false;
};

function TimeSelectRender(props) {
  const { onSubPlanChange, record, startTime, endTime, value, children } = props;
  const disabled = useMemo(() => !record.amount || props.disabled, [record.amount, props.disabled]);
  const { levelPlan = [] } = record;
  const [amount, setAmount] = useState(value?.amount || 0);
  const [time, setTime] = useState(value?.time);
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (visible) {
      setAmount(value?.amount);
      setTime(value?.time);
    }
  }, [visible, value]);

  const getRestAmount = () => {
    const sum = levelPlan.reduce((result, val) => {
      if (!val) return result;
      return result + Number(val.amount);
    }, 0);
    return Number(record.amount) - sum + Number(value?.amount || 0) - Number(amount || 0);
  };

  return (
    <Popover
      trigger={['click']}
      visible={disabled ? false : visible}
      onVisibleChange={(e) => setVisible(e)}
      placement="bottom"
      overlayClassName="days-item-backGround-time-select-panel"
      content={
        <div ref={ref} className="sale-plan-sub-time-panel">
          <TimestampRangePicker
            disabledDate={(current) => disabledDate(current, { startTime, endTime }, levelPlan, value?.time)}
            value={time}
            dropdownClassName="aaa"
            getPopupContainer={() => ref.current}
            className="days-item-backGround-time-select"
            fieldNames={{ start: 'startTime', end: 'endTime' }}
            open={true}
            onChange={(val) => {
              setTime(val);
            }}
          />
          <div className="sale-plan-sub-time-panel-info-block">
            <div>
              <InputNumber
                max={getRestAmount() + Number(amount)}
                min={0}
                value={amount}
                placeholder="时段成交目标"
                onChange={(e) => setAmount(e)}
              />
              <Button
                style={{ marginLeft: 16 }}
                type="primary"
                disabled={!amount || !time}
                onClick={() => {
                  onSubPlanChange({ amount, ...time });
                  setVisible(false);
                }}
              >
                确认
              </Button>
            </div>
            <div className="sale-plan-sub-time-panel-rest">剩余：￥ {getRestAmount()}</div>
          </div>
        </div>
      }
    >
      {children}
    </Popover>
  );
}

function GetCalendarBodyBackGround({ calendarDayList, onPlanChange, rowIndex, ...resProps }) {
  const onSubPlanChange = (val) => {
    const { levelPlan = [] } = resProps.record;
    onPlanChange({ levelPlan: levelPlan.concat(val) }, rowIndex);
  };
  return calendarDayList.map((ele, index) => {
    return ele.daysArray.map((item, key) => {
      return (
        <TimeSelectRender key={index + `${key}` + resProps.rowIndex} onSubPlanChange={onSubPlanChange} {...resProps}>
          <div className="days-item-backGround" />
        </TimeSelectRender>
      );
    });
  });
}

function GetCalendarDaysItems({ record, onPlanChange, rowIndex, ...resProps }) {
  const { levelPlan = [], amount: totalAmount } = record;
  const onSubPlanChange = (val, key) => {
    let _levelPlan = [...levelPlan];
    _levelPlan[key] = val;
    onPlanChange({ levelPlan: _levelPlan }, rowIndex);
  };
  if (!levelPlan) return null;
  return levelPlan.map((ele, key) => {
    return (
      <TimeSelectRender
        record={record}
        onSubPlanChange={(val) => onSubPlanChange(val, key)}
        key={key + `${resProps.rowIndex}`}
        value={{ time: { startTime: ele.startTime, endTime: ele.endTime }, amount: ele.amount }}
        {...resProps}
      >
        <Tooltip
          title={
            <div>
              <div>{'￥' + thousands(Number(ele.amount)) + '/' + '￥' + thousands(totalAmount)}</div>
              {resProps.disabled && <div>达成率{ele.completeRate}</div>}
            </div>
          }
        >
          <div
            className="days-item-block"
            style={{
              width: getDataSpace(ele.startTime, ele.endTime) * 32,
              ...getStyle(rowIndex),
              left: (getDataSpace(resProps.startTime, ele.startTime) - 1) * 32,
            }}
          >
            {getDataSpace(ele.startTime, ele.endTime) < 2 ? (
              <>
                <span>···</span>
                {resProps.disabled && <span>···</span>}
              </>
            ) : (
              <>
                <span className="ellipsis-1-line child-plan-tern">
                  {'￥' + thousands(Number(ele.amount)) + '/' + '￥' + thousands(totalAmount)}
                </span>
                {resProps.disabled && <span className="ellipsis-1-line child-plan-tern">达成率{ele.completeRate}</span>}
              </>
            )}
          </div>
        </Tooltip>
      </TimeSelectRender>
    );
  });
}

function Calendar({ onChange, value = [], startTime, endTime, disabled = false, type = 1, status = 'view' }) {
  const currentMonthDays = useMemo(() => getCalendarArray(moment(), moment().add(21, 'days')), []);
  const [calendarDayList, setCalendarDayList] = useState(currentMonthDays);

  useEffect(() => {
    if (!startTime || !endTime) return;
    setCalendarDayList(getCalendarArray(startTime, endTime));
  }, [startTime, endTime]);

  const getScrollWith = () => {
    let length = 0;
    calendarDayList.map((ele) => {
      length = length + ele.daysArray.length;
    });
    return length * 32 + 153 + 195;
  };

  const getCalendarHeader = () => {
    return calendarDayList.map((ele, index) => {
      return (
        <div key={index} className="product-panel-calender-header-center">
          <span className="product-panel-calender-header-month ellipsis-1-line">{ele.currentMonth}</span>
          <div className="product-panel-calender-header-days">
            {ele.daysArray.map((item, key) => {
              return (
                <div className="days-item" key={key}>
                  {item}
                </div>
              );
            })}
          </div>
        </div>
      );
    });
  };

  function onPlanChange(val, index) {
    const _dataSource = cloneDeep(value);
    _dataSource[index] = Object.assign({}, value[index], val);

    onChange(_dataSource);
  }
  function deletePlan(index) {
    let _dataSource = cloneDeep(value);
    _dataSource.splice(index, 1);
    onChange(_dataSource);
  }

  function deleteAll() {
    onChange([]);
  }

  const columns = [
    {
      title: (
        <div className="product-panel-calender-header-left">
          <span>销售计划</span>
          {status == 'view' ? null : value.length <= 0 ? (
            <a className="product-panel-calender-header-delete" disabled={value.length <= 0}>
              清空
            </a>
          ) : (
            <Delete title="确认清空全部计划?" onConfirm={deleteAll} disabled={value.length <= 0}>
              <a className="product-panel-calender-header-delete" disabled={value.length <= 0}>
                清空
              </a>
            </Delete>
          )}
        </div>
      ),
      width: '195px',
      fixed: 'left',
      className: 'product-panel-calender-left',
      render: (_, record, index) => {
        return (
          <SetPlan
            totalAmount={getTotalAmount(value)}
            disabled={disabled || status == 'view'}
            data={record}
            index={index}
            type={type}
            onSubmit={(val) => onPlanChange(val, index)}
            oneDelete={(index) => deletePlan(index)}
          />
        );
      },
    },
    {
      title: <div className="product-panel-calender-header-center-blok">{getCalendarHeader()}</div>,
      className: 'product-panel-calender-body',
      render: (record, _, index) => {
        return (
          <div style={{ position: 'relative' }} className="days-item-range">
            <GetCalendarBodyBackGround
              onPlanChange={onPlanChange}
              calendarDayList={calendarDayList}
              startTime={startTime}
              endTime={endTime}
              rowIndex={index}
              record={record}
              disabled={status == 'view'}
            />
            <GetCalendarDaysItems
              onPlanChange={onPlanChange}
              startTime={startTime}
              endTime={endTime}
              record={record}
              rowIndex={index}
              disabled={status == 'view'}
            />
          </div>
        );
      },
    },
    {
      title: <div className="product-panel-calender-header-right">已拆分</div>,
      className: 'product-panel-calender-right',
      width: '153px',
      fixed: 'right',
      render(record, index) {
        if (!record.amount) return null;
        let subPlanAmount = 0;
        record.levelPlan?.map((ele) => {
          subPlanAmount = subPlanAmount + Number(ele.amount);
        });
        return (
          <div className="product-panel-calender-right-cell">
            <Tooltip title={'￥' + thousands(subPlanAmount) + '/' + '￥' + thousands(record.amount)}>
              <div className="ellipsis-1-line">
                {'￥' + thousands(subPlanAmount) + '/' + '￥' + thousands(record.amount)}
              </div>
            </Tooltip>
            <div>{Math.round((subPlanAmount / Number(record.amount)) * 100) + '%'}</div>
          </div>
        );
      },
    },
  ];

  return (
    <div className="product-panel-calender">
      {status == 'view' ? null : (
        <div className="total-amount-line">
          总目标（成交金额）：<span className="total-mount">￥{thousands(getTotalAmount(value))}</span>
        </div>
      )}
      <Table
        dataSource={status == 'view' ? value : transLateValue(value, type)}
        pagination={false}
        scroll={{ y: '412px', x: `${getScrollWith()}px` }}
        columns={columns}
      />
    </div>
  );
}

function transLateValue(val = [], type) {
  let _val = [...val];
  if (type == 1 || type == 2) {
    if (val.length < 1) {
      _val.push({ isNew: true });
    }
  } else {
    if (_val.length < 10) {
      _val.push({ isNew: true });
    }

    if (_val.length < 4) {
      _val = Array.from(Array(4), (ele, i) => _val[i] || {});
    }
  }

  return _val;
}

function getTotalAmount(value) {
  return value.reduce((result, val) => {
    if (isNaN(val.amount)) return result;
    return result + Number(val.amount);
  }, 0);
}

export default Calendar;
